import React from 'react';
import {
  Settings as SettingsIcon,
  Logout as LogoutIcon,
  MenuBook as DocsIcon,
} from '@mui/icons-material';
import { NavigationItem, RouteConfig } from './routeTypes';
import { SettingsRoutes } from '@features/settings';
import { BugReportRoutes } from '@features/bug-report/routes';
import { ProtectedRoute } from '../ProtectedRoute';
import { getDocsUrl } from '../../utils/docsUrl';

// Common navigation items available to all roles
export const commonNavigationItems = {
  bottom: [
    {
      label: 'Guide',
      href: getDocsUrl(),
      icon: React.createElement(DocsIcon),
      isBottomItem: true,
      isExternal: true,
    },
    {
      label: 'Settings',
      href: '/app/settings',
      icon: React.createElement(SettingsIcon),
      isBottomItem: true,
    },
    {
      label: 'Logout',
      href: '/logout',
      icon: React.createElement(LogoutIcon),
      isBottomItem: true,
      isLogout: true,
    },
  ] as NavigationItem[],
};

// Common routes available to all roles
export const commonRoutes: RouteConfig[] = [
  {
    path: 'bug-report/*',
    element: React.createElement(ProtectedRoute, null, React.createElement(BugReportRoutes)),
    protected: true,
  },
  {
    path: 'settings/*',
    element: React.createElement(ProtectedRoute, null, React.createElement(SettingsRoutes)),
    protected: true,
  },
];
